<template>
  <v-hover v-slot="{ hover }">
    <v-row
      no-gutters
      align="center"
      class="riga py-1"
      :class="[
        prenotazione.evasa ? 'evasa' : '',
        hover ? 'green lighten-5' : '',
      ]"
    >
      <v-col cols="1" class="pl-2">{{ cliente.numero }}</v-col>

      <v-col cols="3" class="pr-2 d-flex align-center">
        <span class="nome">{{ cliente.nome }}</span>
        <v-tooltip v-if="prenotazione.nota" bottom max-width="360">
          <template v-slot:activator="{ on }">
            <v-icon small color="amber darken-2" class="ml-2" v-on="on">
              mdi-note-text
            </v-icon>
          </template>
          <span>{{ prenotazione.nota }}</span>
        </v-tooltip>
      </v-col>

      <!-- Prossima consegna programmata; la presunta è il ripiego -->
      <v-col cols="2">
        <v-menu
          v-if="!prossima_consegna"
          v-model="menu_data"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <span
              class="modificabile"
              :class="classe_data"
              v-on="on"
            >
              {{ data_presunta }}
            </span>
          </template>
          <v-date-picker
            :value="data_presunta_iso"
            locale="it-it"
            first-day-of-week="1"
            @change="imposta_data"
          />
        </v-menu>

        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on }">
            <span :class="classe_data" v-on="on">
              <v-icon x-small :class="classe_data" class="mr-1">mdi-truck</v-icon>
              {{ data_prossima }}
            </span>
          </template>
          <span>
            {{ consegne_ordinate.length }} consegne programmate ·
            presunta {{ data_presunta }}
          </span>
        </v-tooltip>
      </v-col>

      <!-- Ritiro o consegna -->
      <v-col cols="1">
        <v-menu v-model="menu_ritiro" offset-y>
          <template v-slot:activator="{ on }">
            <span
              class="modificabile"
              :class="prenotazione.ritiro ? 'green--text' : 'blue--text'"
              v-on="on"
            >
              {{ prenotazione.ritiro ? "Ritiro" : "Consegna" }}
            </span>
          </template>
          <v-list dense>
            <v-list-item @click="imposta_ritiro(true)">
              <v-list-item-title class="green--text">Ritiro</v-list-item-title>
            </v-list-item>
            <v-list-item @click="imposta_ritiro(false)">
              <v-list-item-title class="blue--text">Consegna</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>

      <v-col cols="1" class="numero">{{ cc }}</v-col>

      <v-col cols="2" class="numero pr-4">{{ valore }} €</v-col>

      <!-- Stato di ripartizione e conversione in ordini -->
      <v-col cols="1" class="pr-3">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-progress-linear
                :value="ripartizione.percentuale"
                :color="colore_ripartizione"
                height="6"
                rounded
                background-color="grey lighten-3"
              />
              <div class="text-caption grey--text mt-1 stato">
                {{ etichetta_stato }}
              </div>
            </div>
          </template>
          <div>
            <div v-if="!consegne_ordinate.length">Nessuna consegna programmata</div>
            <template v-else>
              <div>
                Ripartito {{ ripartizione.distribuito }} di
                {{ ripartizione.prenotato }} pezzi
              </div>
              <div v-if="ripartizione.mancante > 0">
                {{ ripartizione.mancante }} ancora da assegnare
              </div>
              <div v-else-if="ripartizione.mancante < 0" class="red--text">
                {{ -ripartizione.mancante }} assegnati in più del prenotato
              </div>
              <div>
                {{ ordini_creati }} di {{ consegne_ordinate.length }} consegne
                convertite in ordine
              </div>
            </template>
          </div>
        </v-tooltip>
      </v-col>

      <v-col cols="1" class="text-right pr-2">
        <v-btn icon color="blue" @click="$emit('apri', prenotazione)">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon color="grey" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="stampa">
              <v-list-item-icon><v-icon>mdi-printer</v-icon></v-list-item-icon>
              <v-list-item-title>Stampa</v-list-item-title>
            </v-list-item>
            <v-list-item @click="alterna_evasa">
              <v-list-item-icon>
                <v-icon :color="prenotazione.evasa ? 'green' : 'grey'">
                  {{ prenotazione.evasa ? "mdi-check-circle" : "mdi-check-circle-outline" }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                {{ prenotazione.evasa ? "Segna da evadere" : "Segna evasa" }}
              </v-list-item-title>
            </v-list-item>
            <v-divider />
            <v-list-item @click="conferma_elimina = true">
              <v-list-item-icon><v-icon color="red">mdi-delete</v-icon></v-list-item-icon>
              <v-list-item-title>Elimina</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-dialog v-model="conferma_elimina" width="520">
          <v-card>
            <v-card-title class="red--text text-subtitle-1">
              Elimina la prenotazione di {{ cliente.nome }}
            </v-card-title>
            <v-card-text>
              Verranno persi prodotti, colori e consegne programmate.
              L'operazione non è reversibile.
              <div v-if="ordini_creati" class="mt-3 red--text">
                <v-icon small color="red" class="mr-1">mdi-alert</v-icon>
                Da {{ ordini_creati }} consegne è già stato creato un ordine.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="conferma_elimina = false">Annulla</v-btn>
              <v-btn outlined color="red" :loading="eliminazione" @click="elimina">
                Elimina
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-hover>
</template>

<script>
import moment from "moment";
import printer from "@/service/printer";

// Entro quanti giorni una consegna si considera imminente.
const GIORNI_IMMINENTE = 3;

/**
 * Riga della lista prenotazioni.
 *
 * Data e modalità si modificano qui senza aprire il dettaglio: le passate di
 * pianificazione si fanno scorrendo l'elenco.
 */
export default {
  props: {
    prenotazione: { type: Object, required: true },
  },

  data() {
    return {
      menu_data: false,
      menu_ritiro: false,
      conferma_elimina: false,
      eliminazione: false,
    };
  },

  computed: {
    cliente() {
      const c = this.$store.getters.get_cliente_by_iva(this.prenotazione.cliente);
      return c || { numero: "?", nome: this.prenotazione.cliente };
    },

    consegne_ordinate() {
      return (this.prenotazione.consegne || [])
        .filter((c) => c.ts_data)
        .slice()
        .sort((a, b) => a.ts_data - b.ts_data);
    },

    /**
     * La prima consegna non ancora passata. Se sono tutte passate mostra
     * l'ultima: dice comunque a che punto è la prenotazione, mentre la
     * presunta a quel punto è un dato vecchio.
     */
    prossima_consegna() {
      if (!this.consegne_ordinate.length) return null;
      const oggi = moment().startOf("day").unix();
      return (
        this.consegne_ordinate.find((c) => c.ts_data >= oggi) ||
        this.consegne_ordinate[this.consegne_ordinate.length - 1]
      );
    },

    ts_riferimento() {
      return this.prossima_consegna
        ? this.prossima_consegna.ts_data
        : this.prenotazione.ts_consegna_presunta;
    },

    classe_data() {
      if (this.prenotazione.evasa || !this.ts_riferimento) return "grey--text";
      const giorni = moment
        .unix(this.ts_riferimento)
        .startOf("day")
        .diff(moment().startOf("day"), "days");
      if (giorni < 0) return "red--text";
      if (giorni <= GIORNI_IMMINENTE) return "orange--text text--darken-2";
      return "";
    },

    data_prossima() {
      return moment.unix(this.prossima_consegna.ts_data).format("ddd D MMM");
    },

    data_presunta() {
      return this.prenotazione.ts_consegna_presunta
        ? moment.unix(this.prenotazione.ts_consegna_presunta).format("ddd D MMM")
        : "da definire";
    },

    data_presunta_iso() {
      return this.prenotazione.ts_consegna_presunta
        ? moment.unix(this.prenotazione.ts_consegna_presunta).format("YYYY-MM-DD")
        : `${this.prenotazione.anno}-10-15`;
    },

    ripartizione() {
      return this.$store.getters["crisantemi/ripartizione"](
        this.prenotazione.id
      );
    },

    colore_ripartizione() {
      if (this.ripartizione.mancante < 0) return "red";
      if (!this.consegne_ordinate.length) return "grey lighten-1";
      return this.ripartizione.percentuale >= 100 ? "green" : "amber darken-2";
    },

    etichetta_stato() {
      if (!this.consegne_ordinate.length) return "da pianificare";
      if (this.ripartizione.mancante > 0) return `${this.ripartizione.mancante} da ripartire`;
      if (this.ripartizione.mancante < 0) return "eccedenza";
      return `${this.ordini_creati}/${this.consegne_ordinate.length} in ordine`;
    },

    cc() {
      return this.$store.getters["crisantemi/cc"]({
        id_prenotazione: this.prenotazione.id,
      }).toFixed(1);
    },

    valore() {
      return this.$store.getters["crisantemi/valore"](
        this.prenotazione.id
      ).toFixed(2);
    },

    ordini_creati() {
      return (this.prenotazione.consegne || []).filter(
        (c) => c.id_ordine_creato
      ).length;
    },
  },

  methods: {
    fallito(cosa, err) {
      this.$emit("errore", { cosa, err });
    },

    imposta_data(iso) {
      this.menu_data = false;
      this.$store
        .dispatch("crisantemi/imposta_data_presunta", {
          id: this.prenotazione.id,
          ts: moment(iso).format("X"),
        })
        .catch((err) => this.fallito("Data non aggiornata", err));
    },

    imposta_ritiro(ritiro) {
      this.menu_ritiro = false;
      this.$store
        .dispatch("crisantemi/cambia_ritiro", {
          id: this.prenotazione.id,
          ritiro,
        })
        .catch((err) => this.fallito("Modalità non aggiornata", err));
    },

    alterna_evasa() {
      this.$store
        .dispatch("crisantemi/cambia_evasione", {
          id: this.prenotazione.id,
          evasa: !this.prenotazione.evasa,
        })
        .catch((err) => this.fallito("Stato non aggiornato", err));
    },

    stampa() {
      printer.print_pdf_ordine_crisantemi(this.prenotazione.id);
    },

    async elimina() {
      this.eliminazione = true;
      try {
        await this.$store.dispatch(
          "crisantemi/elimina_prenotazione",
          this.prenotazione.id
        );
        this.conferma_elimina = false;
      } catch (err) {
        this.fallito("Eliminazione non riuscita", err);
      } finally {
        this.eliminazione = false;
      }
    },
  },
};
</script>

<style scoped>
.riga {
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}

.evasa {
  text-decoration: line-through;
  color: rgba(0, 0, 0, 0.38);
}

.nome,
.stato {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.numero {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.modificabile {
  cursor: pointer;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
}

.modificabile:hover {
  border-bottom-color: rgba(0, 0, 0, 0.6);
}
</style>
